import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";

import {
  CellStyleModule,
  ModuleRegistry,
  TooltipModule,
} from "ag-grid-community";

ModuleRegistry.registerModules([CellStyleModule, TooltipModule]);

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  //   <App />
  // </StrictMode>
  <App/>
); 